export class NavigationLink {
  public id?: number;
  public hyperlink?: string;
  public webAddress?: string;
  public isActive?: boolean;
  public order!: number;
}
